/* eslint-disable */
if (!Object.fromEntries) {
    Object.fromEntries = function (entries) {
        const res = {};
        for (let i = 0; i < entries.length; i++) {
            res[entries[i][0]] = entries[i][1];
        }
        return res;
    };
}
if (!Object.entries) {
    Object.entries = function (obj) {
        obj = Object(obj);
        const keys = Object.keys(obj);
        const length = keys.length;
        const rst = [];
        for (let i = 0; i < length; i++) {
            rst[i] = [keys[i], obj[keys[i]]];
        }
        return rst;
    };
}
if (!Object.values) {
    Object.values = function (obj) {
        obj = Object(obj);
        const keys = Object.keys(obj);
        const length = keys.length;
        const values = [];
        for (let i = 0; i < length; i++) {
            values[i] = obj[keys[i]];
        }
        return values;
    };
}
if (!Array.prototype.flat) {
    Array.prototype.flat = function (depth) {
        const flattened = [];
        function flatten(arr, currentDepth) {
            for (let i = 0; i < arr.length; i++) {
                // @ts-expect-error
                if (Array.isArray(arr[i]) && currentDepth < depth) {
                    flatten(arr[i], currentDepth + 1);
                }
                else {
                    flattened.push(arr[i]);
                }
            }
        }
        flatten(this, 0);
        return flattened;
    };
}
if (!Promise.prototype.finally) {
    Promise.prototype.finally = function (callback) {
        if (typeof callback !== 'function') {
            return this.then(callback, callback);
        }
        // get the current promise or a new one
        const P = this.constructor || Promise;
        // return the promise and call the callback function
        // as soon as the promise is rejected or resolved with its value
        return this.then(
        // @ts-expect-error
        (value) => P.resolve(callback()).then(() => value), (err) => 
        // @ts-expect-error
        P.resolve(callback()).then(() => {
            throw err;
        }));
    };
}
